import { cn } from '../../lib/utils';
import type { PanelColumn, PanelProps } from './types';

// Which side takes the page margin and which takes the fixed inner inset is a
// fact about the column a panel lands in, so it is passed in rather than
// inferred from position — a spanning panel makes position and column disagree.
const INSET: Record<PanelColumn, string> = {
  left: 'xl:pl-[var(--page-margin)] xl:pr-8',
  right: 'xl:pl-8 xl:pr-[var(--page-margin)] xl:border-l xl:border-[var(--color-border-faint)]',
  // Touches both viewport edges, so both sides keep the margin the stacked
  // layout already gives them.
  full: 'xl:col-span-2',
};

// One cell of the canvas. Stacked, both sides use the margin; keeping the fixed
// inner inset there is what makes the tablet frame read as misaligned.
export function Panel({ title, subtitle, icon, column = 'full', children, className }: PanelProps) {
  return (
    <section
      className={cn(
        'flex min-h-40 flex-col gap-8 px-[var(--page-margin)] py-8',
        INSET[column],
        className,
      )}
    >
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          {icon ? <span className="flex size-6 shrink-0 items-center">{icon}</span> : null}
          <h2 className="text-2xl leading-[26px] text-[var(--color-text-primary)]">{title}</h2>
        </div>
        {subtitle ? (
          <p className="text-xs leading-[14px] text-[var(--color-text-tertiary)]">{subtitle}</p>
        ) : null}
      </header>
      {children}
    </section>
  );
}
